<form name="PostForm" (ngSubmit)="Validate(PostForm)" #PostForm="ngForm">
    <div class="card">
        <div class="card-header">
            Exit Management
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Employee Name</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div> </div>
                    </div>
                </div>
                <div class="col-md mx-1 px-1 bghighlight">
                    <div class="row">
                        <div class="text-label">Designation</div>
                    </div>
                    <div class="row text-right" style="font-size: 15px;">
                        <div> </div>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 px-1">
                    <label>Reason<span class="text-danger">*</span></label>
                    <!-- <input type="text" [maxLength]="200" class="form-control" name="EmployeeName" placeholder="Ex."
                        [(ngModel)]='Filter.EmpName' #EmployeeName="ngModel" required>
                    <div class="invalid-feedback">
                        Please enter Employee Name!
                    </div> -->
                </div>
                <div class="col-md-12 px-1"><br>
                    <textarea type="text" [maxLength]="200" #Remark="ngModel" name="Remark"
                        placeholder="Remark here ..." [(ngModel)]="Filter.EmpName" rows="10" cols="60"
                        class="description" required></textarea>
                    <!-- <textarea type="text" [(ngModel)]="Filter.EmpName" #Remark="ngModel" name="Remark"
                        class="description" placeholder="Remark here ..." rows="10" cols="60" required></textarea> -->
                    <div class="invalid-feedback">
                        Please enter Remark !
                    </div>
                </div>
            </div>
        </div>
        <div class="card-footer">
            <div class="row">
                <div class="col">
                    <div class="row">
                    </div>
                    <div class="row">
                    </div>
                </div>
                <div class="col-auto">
                    <button type="submit" class="btn btn-primary" [disabled]="isDisabled"><i
                            class="bi bi-box-arrow-right" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Resign':'Loading...'}}</button>
                </div>
            </div>
        </div>
    </div>
</form>